shouldCanonizeResults